import styled from 'styled-components'

export const CookieAlertText = styled.span`
  a {
    font-weight: bold;
    color: #53605e;

    &:hover {
      color: #53605e;
      text-decoration: underline;
    }
  }
  max-width: 290px;
  display: block;
`
